import React from 'react';
import useInitRollout from './use-init-rollout';
import { queryClient } from '../containers/App/App';
import { QueryClientProvider } from 'react-query';

interface InfraProps {
  children: React.ReactNode;
}

const Infra = ({ children }: InfraProps) => {
  useInitRollout();
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default Infra;
